import React from 'react'
import './contacts2.css'
import {Modal} from 'ladder/ux/modal2'
import {InputField} from 'ladder/agents/dashboard/inputs2'
import {EmailInput, PhoneInput, TextInput} from 'ladder/ux/form2'
import {Primary} from 'ladder/ux/button2'
import {Text} from 'ladder/ux/typography2'

export function AddContactModal2(props) {
  const sharedInputProps = {
    fullWidth: true, textSize: '13', textWeight: 'medium', floatingPlaceholder: true, removeBorder: true,
  }

  const renderError = (fieldName) => {
    const maybeError = props.addContactModalErrors?.[fieldName]
    return maybeError && <Text color='red' size='body-15'> {maybeError}</Text>
  }

  return <Modal
    show={props.isAddContactModalOpen}
    width='l'
    height='l'
    title='Add a contact'
    horizontallyCentered
    roundedCorners
    onDismiss={props.onDismissAddContactModal}>
    <div className='add-contact-container'>
      <InputField svgPath='agents/profile/first-name-icon'
                  error={!!props.addContactModalErrors?.firstName}
                  inputDom={<TextInput
                    {...sharedInputProps}
                    placeholder='First name'
                    value={props.addContactModalContact.firstName}
                    onChange={props.addContactModalUpdateContact.firstName}/>}/>
      {renderError('firstName')}
      <InputField svgPath='agents/profile/last-name-icon'
                  error={!!props.addContactModalErrors?.lastName}
                  inputDom={<TextInput
                    {...sharedInputProps}
                    placeholder='Last name'
                    value={props.addContactModalContact.lastName}
                    onChange={props.addContactModalUpdateContact.lastName}/>}/>
      {renderError('lastName')}
      <InputField svgPath='agents/profile/professional-email-icon'
                  error={!!props.addContactModalErrors?.email}
                  inputDom={<EmailInput
                    {...sharedInputProps}
                    placeholder='Email'
                    value={props.addContactModalContact.email}
                    onChange={props.addContactModalUpdateContact.email}/>}/>
      {renderError('email')}
      <InputField svgPath='agents/profile/phone-icon'
                  error={!!props.addContactModalErrors?.phoneNumber}
                  inputDom={<PhoneInput
                    {...sharedInputProps}
                    placeholder='Phone (optional)'
                    value={props.addContactModalContact.phoneNumber}
                    onChange={props.addContactModalUpdateContact.phoneNumber}/>}/>
      {renderError('phoneNumber')}
      <div className='button'>
        <Primary name='add-contact'
                 fullWidth
                 roundedCorners
                 textTransformDisabled
                 loading={props.isCreateContactLoading}
                 disabled={props.isCreateContactLoading}
                 onClick={props.onClickCreateContact}>
          Save
        </Primary>
      </div>
    </div>
  </Modal>
}
